/**
 * Created by Ivan on 23.03.2025
 */

const ScoreBarView = cc.Node.extend({
    ctor: function (scoreBar) {
        this.scoreBar = scoreBar;

        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setAlignment(cleverapps.styles.ScoreBarView.position);

        this.createBar();
        this.createAvatars();

        this.onResize();

        this.setCascadeOpacityEnabledRecursively(true);

        scoreBar.on("updatePoints", this.updatePoints.bind(this), this);
        scoreBar.on("completeStage", this.completeStage.bind(this), this);
        scoreBar.on("updateStage", this.updateStage.bind(this), this);
    },

    createBar: function () {
        const styles = cleverapps.styles.ScoreBarView;

        const bar = this.bar = new ScaledProgressBar({
            progress: bundles.score_bar.frames.score_progress_png,
            background: bundles.score_bar.frames.score_progress_bg_png
        });
        this.minWidth = bar.width;
        this.addChild(bar);
        bar.setAlignment(styles.bar);
        bar.setLength(styles.size[cleverapps.resolution.mode].width);
        this.updateBar();

        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(this.bar, () => {
                Game.currentGame.score.addPoints(this.scoreBar.currentGoal - this.scoreBar.currentPoints);
                Game.currentGame.counter.setTimeout(() => {}, 1000);
            });
        }
    },

    updateBar: function () {
        this.bar.setGoal(this.scoreBar.currentGoal);
        this.bar.setPercentage(this.scoreBar.currentPoints, {
            animated: true
        });
    },

    updatePoints: function () {
        if (this.scoreBar.movingNextStage) {
            return;
        }

        this.updateBar();

        const pos = this.calcAvatarPosition(true);
        this.userAvatar.moveAnimation(pos, pos.x <= this.minWidth);
        this.opponentAvatar.moveAnimation(this.calcAvatarPosition());
    },

    createAvatars: function () {
        const userAvatar = this.userAvatar = new ScoreBarAvatar(this.scoreBar.user, { loading: true, line: true });
        this.addChild(userAvatar);

        const opponentAvatar = this.opponentAvatar = new ScoreBarAvatar(this.scoreBar.getPlayer(), { loading: true });
        this.addChild(opponentAvatar);
    },

    completeStage: function () {
        this.opponentAvatar.removeAnimation();
        cleverapps.persist.sendNode(this.opponentAvatar, "ScoreBarAvatar");

        const isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;
        const bgHighlight = this.bgHighlight = new cleverapps.Spine(bundles.score_bar.jsons.score_bg_rays_json);
        this.bar.addChild(bgHighlight, -1);
        bgHighlight.setSkin("700");
        bgHighlight.setAlignment(this.bar.width / 2, this.bar.height / 2);
        bgHighlight.setAnimationAndIdleAfter(isVertical ? "open2" : "open", isVertical ? "idle2" : "idle");

        const fgHighlight = this.fgHighlight = new cleverapps.Spine(bundles.score_bar.jsons.score_front_rays_json);
        this.bar.addChild(fgHighlight);
        fgHighlight.setSkin("yellow");
        fgHighlight.setAlignment(this.bar.width / 2, this.bar.height / 2);
        fgHighlight.setAnimationAndIdleAfter(isVertical ? "open2" : "open", isVertical ? "idle2" : "idle");
    },

    updateStage: function () {
        this.opponentAvatar = new ScoreBarAvatar(this.scoreBar.getPlayer());
        this.addChild(this.opponentAvatar);
        this.opponentAvatar.showAnimation(this.calcAvatarPosition());

        const isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;
        this.bgHighlight.setAnimation(0, isVertical ? "close2" : "close", false);
        this.bgHighlight.setCompleteListenerRemove();
        this.fgHighlight.setAnimation(0, isVertical ? "close2" : "close", false);
        this.fgHighlight.setCompleteListenerRemove();

        this.userAvatar.moveAnimation(this.calcAvatarPosition(true));

        this.bar.setGoal(this.scoreBar.currentGoal);
        this.bar.setPercentage(this.scoreBar.currentGoal);
        this.bar.setPercentage(this.scoreBar.currentPoints, {
            animated: true
        });
    },

    onResize: function () {
        const styles = cleverapps.styles.ScoreBarView;

        this.bar.setLength(styles.size[cleverapps.resolution.mode].width);
        this.setContentSize(this.bar.getContentSize());

        this.bar.setAlignment(styles.bar);
        this.userAvatar.setAlignment(this.calcAvatarPosition(true));
        this.opponentAvatar.setAlignment(this.calcAvatarPosition());
    },

    calcAvatarPosition: function (isUser) {
        const styles = cleverapps.styles.ScoreBarView.avatars;
        const offsetY = styles.offset[cleverapps.resolution.mode].height;
        const avatarY = this.bar.y + this.bar.height + offsetY;
        let position = cc.p(this.bar.x + Math.floor(this.bar.width / 2), avatarY);

        if (isUser) {
            let avatarX = this.bar.x - Math.floor(this.bar.width / 2) + this.bar.width * this.scoreBar.calcPercent();
            if (avatarX < this.minWidth && avatarX !== 0) {
                avatarX = this.minWidth;
            }

            position = cc.p(avatarX, avatarY);
        } else {
            const userPos = this.calcAvatarPosition(true);
            const shiftOffset = Math.max(0, ScoreBarView.OVERLAP_PERCENT * this.bar.width - (this.bar.width - userPos.x));
            position.x += shiftOffset;
        }

        return position;
    },

    hide: function (callback) {
        this.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.RemoveSelf()
        )).setFinalize(callback);
    }
});

ScoreBarView.OVERLAP_PERCENT = 0.13;

cleverapps.styles.ScoreBarView = {
    position: [
        { x: { align: "center", dx: 10 }, y: { align: "top", dy: -250 } },
        { x: { align: "center", dx: -260 }, y: { align: "top", dy: -300 } },
        { x: { align: "center", dx: -50 }, y: { align: "top", dy: -170 } }
    ],

    bar: {
        x: { align: "center" },
        y: { align: "center" }
    },

    avatars: {
        offset: [
            { height: 46 },
            { height: 64 },
            { height: 81 }
        ]
    },

    size: [{ width: 450 }, { width: 700 }, { width: 700 }]
};